'use client'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
export default function TabsSection({
  params,
  searchParams,
  community,
  racingContent,
  aboutContent,
  membersContent,
}) {
  const router = useRouter()
  const [activeTab, setActiveTab] = useState(searchParams?.tabName || 'racing')

  const handleTabChange = (value) => {
    setActiveTab(value)
    router.push(`/c/${params.communitySlug}?tabName=${value}`, {
      scroll: false,
    })
  }

  // ensure discord links begins with https://discord.gg/
  let discordLink = null
  if (community.joinLinkService === 'discord-server') {
    discordLink = community.joinLinkUrl

    if (discordLink && !discordLink.includes('discord')) {
      discordLink = `https://discord.gg/${discordLink}`
    }
  }

  return (
    <div className="grid-indent mt-8 min-w-0">
      <Tabs
        defaultValue="racing"
        className="w-full"
        onValueChange={(value) => handleTabChange(value)}
        value={activeTab}
      >
        <TabsList className="overflow-x-auto overflow-y-hidden">
          <TabsTrigger
            value="racing"
            className="mr-6! px-0! desktop-xs:ml-0! ml-6"
          >
            Racing
          </TabsTrigger>

          {community.descriptionHtml && (
            <TabsTrigger value="about" className="ml-0! mr-6! px-0!">
              About
            </TabsTrigger>
          )}

          <TabsTrigger value="members" className="ml-0! mr-6! px-0!">
            Members
          </TabsTrigger>
          {discordLink && (
            <TabsTrigger
              value="discord"
              onClick={() => window.open(discordLink, '_blank')}
              className="ml-0! mr-6! px-0!"
            >
              Discord
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="racing" className="min-w-0">
          {racingContent}
        </TabsContent>

        {community.descriptionHtml && (
          <TabsContent value="about" className="min-w-0">
            {aboutContent}
          </TabsContent>
        )}

        <TabsContent value="members" className="min-w-0">
          {membersContent}
        </TabsContent>

        <TabsContent value="discord">
          <div className="mt-6 flex h-[300px] w-full items-center rounded-sm border border-neutral-blue-700 bg-neutral-blue-800">
            <div className="mx-auto h-fit w-fit px-8 text-center font-inter text-h-5-sm font-semibold text-neutral-blue-500 desktop-xs:px-0 desktop-xs:text-h-5">
              <p>
                You will be redirected to {community.name}'s Discord in a new
                tab.
              </p>
              <p>
                If you are not redirected, please{' '}
                <a
                  href={discordLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer underline"
                >
                  click here
                </a>
              </p>
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  )
}
